import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=c8765c42"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8765c42')) {
      api.createRecord('c8765c42', component.options)
    } else {
      api.reload('c8765c42', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=c8765c42", function () {
      api.rerender('c8765c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Profile.vue"
export default component.exports